import axios from "axios";

export const prodGatewayAxios = axios.create({
  baseURL: process.env.VUE_APP_LOCAL_API_URL,
  timeout: 120000, //ms
  headers: {
    "Content-Type": "application/json",
  },
});
